import Vue from "vue";
import App from "./App.vue";
import VueResource from "vue-resource";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@mdi/font/css/materialdesignicons.css";
import "@/assets/style.css";

Vue.use(VueResource);

Vue.config.productionTip = false;
Vue.prototype.apiURL = process.env.NODE_ENV === "production"
  ? "/pi-screener/stock/api/v1"
  : "http://localhost:5555/api/v1"

Vue.http.interceptors.push(req => {
  req.url = `${Vue.prototype.apiURL}${req.url}`;
  var url_string = window.location.href;
  var url = new URL(url_string);
  var pid = url.searchParams.get("pid");
  if (pid) {
    req.headers.set("pid", pid);
  }
});

new Vue({
  store,
  vuetify,
  async beforeCreate() { //@Todo: wrap it to init function
    await this.$store.dispatch('fetchUser')
    this.$store.dispatch("fetchSubheads");
    this.$store.dispatch("fetchScreens");
    this.$store.dispatch("fetchCustomScreeners");
    this.$mount('#app')
  },
  render: h => h(App)
});
